import { proxy } from 'valtio'

export const goodwayStore = proxy({
  ma960: 0 as number,
  txf: 0 as number,
  pageState: 'index' as 'index' | 'monitors' | 'os-monitors',
})
